import React from "react";
import { Paper } from "Components/Base/Surfaces/Paper";
import styled from "styled-components";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { Box } from "Components/Base/Layout/Box";

const StyledMUIPaperHeader = styled(Paper)``;

const PaperHeader = ({
  heading,
  content,
  headerVariant = "h6",
  marginBottom,
}) => {
  return (
    <StyledMUIPaperHeader>
      <Box mb={marginBottom}>
        <Typography variant={headerVariant} mb={marginBottom}>
          {heading}
        </Typography>
      </Box>
      {content}
    </StyledMUIPaperHeader>
  );
};

export default PaperHeader;
